import { useState, useEffect } from 'react'

/**
 * Custom hook for managing form state in the AssignLicense component
 * @param {Object} initialData - Initial form data from defaultSiteData
 * @returns {Object} Form state and setters
 */
const useFormState = initialData => {
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('')
  const [isAssignmentConfirmed, setIsAssignmentConfirmed] = useState(false)
  const [isTosConfirmed, setIsTosConfirmed] = useState(false)
  const [netSuiteCustomerId, setNetSuiteCustomerId] = useState('')
  const [nsCustomerId, setNsCustomerId] = useState('')
  const [region, setRegion] = useState('')
  const [siteName, setSiteName] = useState('')

  // Initialize form with default data
  useEffect(() => {
    if (initialData) {
      const {
        city: defaultCity,
        country: defaultCountry,
        netSuiteCustomerId: defaultNetSuiteCustomerId,
        region: defaultRegion,
        siteName: defaultSiteName,
      } = initialData

      setCity(defaultCity || '')
      setCountry(defaultCountry || '')
      setRegion(defaultRegion || '')
      setNetSuiteCustomerId(
        defaultNetSuiteCustomerId ||
          (!defaultNetSuiteCustomerId && defaultSiteName ? 0 : ''),
      )
      setSiteName(defaultSiteName || '')
    }
  }, [initialData])

  return {
    city,
    setCity,
    country,
    setCountry,
    isAssignmentConfirmed,
    setIsAssignmentConfirmed,
    isTosConfirmed,
    setIsTosConfirmed,
    netSuiteCustomerId,
    setNetSuiteCustomerId,
    nsCustomerId,
    setNsCustomerId,
    region,
    setRegion,
    siteName,
    setSiteName,
  }
}

export default useFormState
